import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-wheel-action',
    templateUrl: './wheel-action.component.html',
    styleUrls: ['./wheel-action.component.scss']
})
export class WheelActionComponent implements OnInit {
    @Input() element: any;
    // @Input() name: any;
    @Input() icons: string;
    @Input() viewOn: boolean = false;
    @Input() executeOn: boolean = false;
    @Input() defaultView: boolean = false;
    @Input() cancelOn: boolean = false;
    @Input() activeOn: boolean = false;
    @Input() editOn: boolean = false;
    @Input() awardBadgeOn: boolean = false;
    @Input() returnBadgeOn: boolean = false;
    @Input() sendInvitationOn: boolean = false;
    @Input() editResourceReservationOn: boolean = false;
    @Input() sendAvailabilityMailOn: boolean = false;
    @Input() assignSiteOn: boolean = false;
    @Input() blockOn: boolean = false;
    @Input() restoreOn: boolean = false;
    @Input() deleteOn: boolean = false;
    @Input() addUserOn: boolean = false;
    @Input() deleteReservationOn: boolean = false;
    @Input() acceptOn: boolean = false;
    @Input() viewCertificateOn: boolean = false;
    @Input() declineOn: boolean = false;
    @Input() logOn: boolean = false;
    @Input() commentOn: boolean = false;
    @Input() lockOn: boolean = false;
    @Input() qrOn: boolean = false;
    @Input() dissOn: boolean = false;
    @Input() planOn: boolean = false;
    @Input() divisionOn: boolean = false;
    @Input() unitOn: boolean = false;
    @Input() route: string;
    @Input() editCreditOn:boolean = false;
    @Input() reservationOn:boolean = false;
    @Input() removeReservationOn:boolean = false;
    @Input() changeRoleOn: boolean = false;
    @Input() zone: boolean = false;
    @Input() restrictedModeOn: boolean = false;
    @Input() departmentsQuotasOn: boolean = false;
    @Input() duplicateOn: boolean = false;
    @Input() listVenuesOn: boolean = false;
    @Input() resCalenderOn: boolean = false;
    @Input() eventLogOn: boolean = false;
    @Input() changeLogOn: boolean = false;
    @Input() unLockOn: boolean = false;
    @Input() reBook: boolean = false;
    @Input() resetOn: boolean = false;

    @Output() view = new EventEmitter<any>();
    @Output() accept = new EventEmitter<any>();
    @Output() decline = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<any>();
    @Output() active = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();
    @Output() block = new EventEmitter<any>();
    @Output() restore = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() addUser = new EventEmitter<any>();
    @Output() deleteReservation = new EventEmitter<any>();
    @Output() changeRole = new EventEmitter<any>();
    @Output() log = new EventEmitter<any>();
    @Output() comment = new EventEmitter<any>();
    @Output() lock = new EventEmitter<any>();
    @Output() qr = new EventEmitter<any>();
    @Output() plan = new EventEmitter<any>();
    @Output() editCredit = new EventEmitter<any>();
    @Output() reservation = new EventEmitter<any>();
    @Output() removeReservation = new EventEmitter<any>();
    @Output() awardBadge = new EventEmitter<any>();
    @Output() returnBadge = new EventEmitter<any>();
    @Output() sendInvitation = new EventEmitter<any>();
    @Output() editResourceReservation = new EventEmitter<any>();
    @Output() sendAvailabilityMail = new EventEmitter<any>();
    @Output() assignSite = new EventEmitter<any>();
    @Output() siteZone = new EventEmitter<any>();
    @Output() division = new EventEmitter<any>();
    @Output() unit = new EventEmitter<any>();
    @Output() restrictedMode = new EventEmitter<any>();
    @Output() departmentsQuotas = new EventEmitter<any>();
    @Output() duplicate = new EventEmitter<any>();
    @Output() execute = new EventEmitter<any>();
    @Output() listOfVenues = new EventEmitter<any>();
    @Output() reservationCalender = new EventEmitter<any>();
    @Output() eventLog = new EventEmitter<any>();
    @Output() changeLog = new EventEmitter<any>();
    @Output() unlock = new EventEmitter<any>();
    @Output() reBookLog = new EventEmitter<any>();
    @Output() reset = new EventEmitter<any>();

    // @Input() id: any;

    constructor() {
    }

    ngOnInit(): void {
    }

    viewDetail() {
        this.view.emit(this.element)
    }

    cancelEvent() {
        this.cancel.emit(this.element)
    }

    editEvent() {
        this.edit.emit(this.element)
    }

    sendInvitationMethod(): any {
        this.sendInvitation.emit(this.element)
    }

    editResourceReservationMethod(): any {
        this.editResourceReservation.emit(this.element)
    }

    sendAvailabilityMailMethod(): any {
        this.sendAvailabilityMail.emit(this.element)
    }

    assignSiteMethod(): any {
        this.assignSite.emit(this.element)
    }
    returnBadgeMethod(): any {
        this.returnBadge.emit(this.element)
    }
    awardBadgeMethod(): any {
        this.awardBadge.emit(this.element)
    }


    blockEvent() {
        this.block.emit(this.element)
    }

    restoreEvent() {
        this.restore.emit(this.element)
    }

   activeEvent() {
      this.active.emit(this.element)
   }

    acceptInvitation(){
        this.accept.emit(this.element)
    }
    declineInvitation(){
        this.decline.emit(this.element)
    }
    changeSelectedAttendeeRole() {
        this.changeRole.emit(this.element)
    }
    deleteEvent() {
        this.delete.emit(this.element)
    }

    addUserEvent() {
        this.addUser.emit(this.element)
    }

    deleteReservationPeopleCaring() {
        this.deleteReservation.emit(this.element)
    }

    changeDetails() {
        this.log.emit(this.element)
    }

    commentAction() {
        this.comment.emit(this.element)
    }

    openUnlock() {
        this.lock.emit(this.element)
    }

    openQR() {
        this.qr.emit(this.element)
    }

    planAction() {
        this.plan.emit(this.element)
    }
    editEventCredit(){
        this.editCredit.emit(this.element)
    }
    reservationResource(){
        this.reservation.emit(this.element)
    }

    removeReservationResource(){
        this.removeReservation.emit(this.element)
    }
    opensiteZone(){
        this.siteZone.emit(this.element)
    }

    openListVenuesOn(){
        this.listOfVenues.emit(this.element)
    }

    divisionEvent(){
        this.division.emit(this.element);
    }

    unitEvent(){
        this.unit.emit(this.element);
    }

    restrictedModeMethod(): any {
        this.restrictedMode.emit(this.element)
    }

    departmentsQuotasMethod(): any {
        this.departmentsQuotas.emit(this.element)
    }

    duplicateMethod(): any {
        this.duplicate.emit(this.element)
    }
    executeMethod(): any {
        this.execute.emit(this.element)
    }

    reservationExec():any{
        this.reservationCalender.emit(this.element)
    }

    showLog():any{
        this.eventLog.emit(this.element)
    }
    changeLogMethod():any{
        this.changeLog.emit(this.element)
    }
    unlockMethod() {
        this.unlock.emit(this.element)
    }
    reBookMethod():any{
        this.reBookLog.emit(this.element)
    }
    resetEvent() {
        this.reset.emit(this.element)
    }
}
